"use client";

import { captureException, withScope } from "@sentry/nextjs";
import { getOrCreateStore } from "modules/lib/with-redux-store";

export default class PASentry {
  static logException(error: any, errorInfo: any = null, paylaod: any = null, tags = []) {
    if (!process.browser) {
      if (error) {
        withScope((scope) => {
          if (paylaod) {
            scope.setExtra("paylaod", paylaod);
          }
          captureException(error);
        });
      } else {
        withScope((scope) => {
          if (paylaod) {
            scope.setExtra("paylaod", paylaod);
          }
          captureException(error);
        });
      }
      return;
    }

    try {
      const reduxStore = getOrCreateStore();
      const { garage, authenticationState, shoppingCart } = reduxStore.getState();
      const { selectedVehicle, vehicles } = garage;
      const { firstName } = authenticationState;

      withScope((scope) => {
        scope.setExtra("vehicles", vehicles);
        if (shoppingCart.availableItems.length > 0) {
          scope.setExtra("shoppingCart", JSON.stringify(shoppingCart));
        }
        if (paylaod) {
          scope.setExtra("paylaod", paylaod);
        }
        if (selectedVehicle) {
          const {
            make, model, year, fitmentOptions,
          } = selectedVehicle;
          const fitmentOptionsString = fitmentOptions.reduce((acc, option) => acc + option.optionValue, "");
          scope.setTag("selected_vehicle", `${make} ${model} ${year} ${fitmentOptionsString}`);
          scope.setTag("customerBrowserId", window.customerBrowserId);
        }
        scope.setTag("customerBrowserId", window.customerBrowserId);
        scope.setUser({ firstName });

        if (errorInfo) {
          Object.keys(errorInfo)
            .forEach((key) => {
              scope.setExtra(key, errorInfo[key]);
            });
        }

        if (tags) {
          tags.forEach((tag) => {
            scope.setTag(tag.key, tag.value);
          });
        }
        captureException(error);
      });
    } catch (err) {
      if (process.browser) {
        captureException(err);
      }
    }
  }
}
